import React, { Component } from 'react';
import { BrowserRouter as Router, Route, Link, Redirect, NavLink, HashRouter } from "react-router-dom";
import CKEditor from "react-ckeditor-component";
import Header from './../../Header';
import HeaderMob from './../../HeaderMob';
import $ from 'jquery';
import CryptoJS from 'crypto-js';
import config from 'react-global-configuration';
import DraftEditor from '../common/DraftEditor';

class NoteSnippetEdit extends Component {
    constructor(props) {
        super(props);
        var has_local_data = localStorage.getItem('encdata') ? 1 : 0;
        var localdata = has_local_data ? this.decrypt(localStorage.getItem('encdata'), 0) : '';
        this.state = {
            owners: [],
            apiUrl: this.decryptconfigdata('apiUrl'),
            userId: has_local_data ? localdata.user_id : '',
            userName: has_local_data ? localdata.user_name : '',
            userAuthKey: has_local_data ? localdata.user_key : '',
            NoteEdit: localStorage.getItem('ticket_note'),
            message: '',
        };
    }

    decryptconfigdata(configkey) {
        var key = CryptoJS.enc.Hex.parse(config.get('enc_key'));
        var iv = CryptoJS.enc.Hex.parse(config.get('enc_iv'));
        var bytes = CryptoJS.AES.decrypt(config.get(configkey), key, {
            iv
        });
        var plaintext = bytes.toString(CryptoJS.enc.Utf8);
        return plaintext;
    }

    decrypt(findresponse, flg) {
        var key = CryptoJS.enc.Hex.parse(config.get('enc_key'));
        var iv = CryptoJS.enc.Hex.parse(config.get('enc_iv'));
        var res = flg ? findresponse.encdata : findresponse;
        var bytes = CryptoJS.AES.decrypt(res, key, {
            iv
        });
        var plaintext = bytes.toString(CryptoJS.enc.Utf8);
        return JSON.parse(plaintext);
    }

    rawjsonparse(findresponse, flg) {
        return findresponse;
    }

    goBack() {
        window.history.back();
    }

    // REPLACED ckOnChange WITH SIMPLE HTML HANDLER
    handleEditorChange = (htmlContent) => {
        this.setState({ NoteEdit: htmlContent });
    };

    updateSnippetNote() {
        document.getElementById("add_note").innerHTML = "Sending....";
        const fd = new FormData;
        document.getElementById("add_note").disabled = true;
        fd.append('note', this.state.NoteEdit);
        fetch(this.state.apiUrl + '/ErRest/updateNoteSnippet/id/' + this.props.match.params.snippetId + '/userAuthKey/' + this.state.userAuthKey + '/userId/' + this.state.userId, {
            method: 'POST',
            dataType: 'json',
            body: fd,
        })
            .then((Response) => Response.json())
            .then((findresponse) => {
                findresponse = this.rawjsonparse(findresponse, 1);
                console.log(findresponse);
                document.getElementById("add_note").disabled = false;
                document.getElementById("add_note").innerHTML = "update";
                if (findresponse.code == 200) {
                    this.setState({ message: findresponse.msg }, function () {
                        window.location.href = '/viewSnippet/' + this.state.snippet_id;
                    });
                } else {
                    this.setState({ message: findresponse.msg })
                }
            })
    }

    getnoteDetails() {
        fetch(this.state.apiUrl + '/ErRest/NoteSnippetEdit/id/' + this.props.match.params.snippetId + '/userAuthKey/' + this.state.userAuthKey)
            .then((Response) => Response.json())
            .then((findresponse) => {
                findresponse = this.rawjsonparse(findresponse, 1);
                console.log(findresponse)
                this.setState({
                    NoteEdit: findresponse.notedetails,
                    owners: findresponse.owners,
                    snippet_id: findresponse.snippet_id,
                })
            })
    }

    componentWillMount() {
        document.title = "Intranet | Edit Note";
        if (!localStorage.getItem('userLogin')) {
            this.setState({ redirect: true });
        }
        this.getnoteDetails();
    }

    render() {
        if (this.state.redirect) {
            return (
                <Redirect to={'/login'} />
            )
        }
        return (
            <div>
                <Header brecum_name="er" brecum_page="Note Detail" NoteEdit={this.state.NoteEdit} />
                <div class="right_col">
                    <div class="intranet_body">
                        <div class="title mob"><HeaderMob page_name="Update Note" /></div>
                        <div class="top-row-form">
                            <div class="form-group">
                                <label></label>
                                <DraftEditor
                                    content={this.state.NoteEdit}
                                    onChange={this.handleEditorChange}
                                    placeholder=""
                                />

                            </div>
                            <button type="submit" name="add_note" id="add_note" className="btn btn-sky mob-btn" onClick={() => this.updateSnippetNote()}>Update</button>
                            <button type="button" className="btn btn-blue" onClick={() => this.goBack()} >Back</button>
                            <div className="clear"></div>
                        </div>
                    </div>
                    <span style={{ color: "red" }}>{this.state.message}</span>
                </div>
            </div>
        )
    }
}
export default NoteSnippetEdit;


// WEBPACK FOOTER //
// ./src/components/er/NoteSnippetEdit.js